import React from 'react';
import Reveal from './Reveal';
import { getLandingIcon } from './iconMap';

const DEFAULT_FEATURES = [
  { icon: 'users', title: 'اللاعبون والاشتراكات', description: 'ملفات لاعبين كاملة مع اشتراكات ومدفوعات وتنبيهات تجديد وانتهاء تلقائية.' },
  { icon: 'shield', title: 'الفرق والفئات', description: 'تنظيم الفرق والفئات العمرية وربط اللاعبين والمدربين بها بسهولة.' },
  { icon: 'briefcase', title: 'الموظفون والعقود', description: 'ملفات الموظفين وعقود العمل والرواتب والتنبيهات المرتبطة بها.' },
  { icon: 'scan', title: 'الحضور والانصراف', description: 'تسجيل الحضور بالكاميرا أو رمز QR للاعبين والموظفين في ثوانٍ.' },
  { icon: 'wallet', title: 'الإدارة المالية', description: 'إيرادات ومصروفات وفواتير معزولة بالكامل لكل منشأة.' },
  { icon: 'chart', title: 'مركز التقارير والتحليلات', description: 'تقارير رياضية ومالية متقدمة قابلة للتصدير والطباعة.' },
  { icon: 'dumbbell', title: 'العمل الفني وأدوات المدربين', description: 'خطط تدريبية وتحليل مباريات وأدوات دعم فني للمدربين.' },
  { icon: 'qrcode', title: 'البطاقات ورموز QR', description: 'بطاقات لاعبين وموظفين قابلة للطباعة برمز QR للتحقق السريع.' },
];

export const LandingFeatures = ({ landing }) => {
  const items = Array.isArray(landing?.features) && landing.features.length ? landing.features : DEFAULT_FEATURES;

  return (
    <section id="features" className="mx-auto max-w-7xl px-5 py-24 md:py-32" data-testid="landing-features">
      <Reveal>
        <div className="max-w-2xl text-start">
          <span className="text-sm font-bold uppercase tracking-wider text-teal-400">{landing?.features_title ? '' : 'مميزات المنصة'}</span>
          <h2 className="font-display mt-3 text-2xl font-bold text-white sm:text-3xl lg:text-4xl" data-testid="landing-features-title">
            {landing?.features_title || 'مميزات المنصة'}
          </h2>
          <p className="mt-3 text-slate-400" data-testid="landing-features-subtitle">
            {landing?.features_subtitle || 'كل ما تحتاجه منشأتك الرياضية، في نظام واحد'}
          </p>
        </div>
      </Reveal>

      <div className="mt-10 grid auto-rows-fr grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((f, i) => {
          const FeatureIcon = getLandingIcon(f.icon);
          return (
            <Reveal key={i} delay={i * 60}>
              <div
                className="group flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.02] p-6 transition-all hover:-translate-y-1 hover:border-teal-500/50"
                data-testid={`landing-feature-${i}`}
              >
                <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-teal-500/10 transition-colors group-hover:bg-teal-500/20">
                  <FeatureIcon className="h-5 w-5 text-teal-400" />
                </div>
                <h3 className="font-display text-base font-bold text-white">{f.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{f.description}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};

export default LandingFeatures;
